import React, {FC} from 'react';
import {Route, RouteComponentProps} from 'react-router-dom';

/**
 * Public route don't need any auth any auth can access
 * @param Component
 * @param rest
 * @constructor
 */
const PublicRoute: FC<any> = ({component: Component, ...rest}) => (
    <Route {...rest}
           render={(props: RouteComponentProps) => <Component {...props} />}
    >{rest.children}</Route>
);

export default PublicRoute;
